import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import logo from '../../assets/logotyper/logo_original.svg';
import { MdArrowDropDown, MdMenu, MdClose } from "react-icons/md";
import { FiExternalLink } from "react-icons/fi";

const Navbar = () => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownVisible(!dropdownVisible);
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="navbar-container" role="banner">
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="Cycle Solutions" />
        </Link>
      </div>
      <nav className={`navbar ${menuVisible ? 'expanded' : ''}`} aria-label="Huvudnavigering">
        <ul className="nav-menu">
          <li className="nav-item"><Link to="/" onClick={() => setMenuVisible(false)}>Hem</Link></li>
          <li className="nav-item"><Link to="/about" onClick={() => setMenuVisible(false)}>Om oss</Link></li>
          <li className="nav-item products-dropdown" ref={dropdownRef}>
            <Link to="" onClick={toggleDropdown} aria-expanded={dropdownVisible} aria-haspopup="true">
              Produkter <MdArrowDropDown className={`arrow-icon ${dropdownVisible ? 'up' : ''}`} />
            </Link>
            <ul className={`dropdown ${dropdownVisible ? 'show' : ''}`}>
              <li><Link to="/produkter" onClick={() => setMenuVisible(false)}>Samtliga produkter</Link></li>
              <li><Link to="/produkter/balpressar" onClick={() => setMenuVisible(false)}>Balpressar</Link></li>
              <li><Link to="/produkter/komprimatorer" onClick={() => setMenuVisible(false)}>Komprimatorer</Link></li>
              <li><Link to="/produkter/ovrigt" onClick={() => setMenuVisible(false)}>Övrigt</Link></li>
              <li><Link to="/produkter/brain" onClick={() => setMenuVisible(false)}>BRA-in datastyrning</Link></li>
              <li>
                <a
                  href="https://komptrade.se/maskiner"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="external-link"
                  title="Öppnas på komptrade.se i en ny flik"
                  onClick={() => setMenuVisible(false)}
                >
                  Begagnat <FiExternalLink aria-hidden="true" />
                  <span className="sr-only"> (extern sajt, öppnas i ny flik)</span>
                </a>
              </li>
            </ul>
          </li>
          <li className="nav-item"><Link to="/service" onClick={() => setMenuVisible(false)}>Service</Link></li>
          <li className="nav-item"><Link to="/nyheter" onClick={() => setMenuVisible(false)}>Nyheter & Referenser</Link></li>
        </ul>
        <Link to="/kontakt" className="cta-button" onClick={() => setMenuVisible(false)}>Kontakta oss</Link>
      </nav>
      <button
        className="menu-toggle"
        onClick={toggleMenu}
        aria-label={menuVisible ? "Stäng meny" : "Öppna meny"}
        aria-expanded={menuVisible}
      >
        {menuVisible ? <MdClose /> : <MdMenu />}
      </button>
    </header>
  );
};

export default Navbar;
